
import { v4 as uuid } from "uuid";
import { PropType } from "vue";

interface WidgetId {
}

interface YcCaptcha {
    reset(): void;

    render(element: any, params: object): WidgetId;

    getResponse(widgetId: WidgetId): string;

    execute(widgetId: WidgetId): void;

    destroy(widgetId: WidgetId): void;

    subscribe(widgetId: WidgetId, name: string, on: any): () => void;
}

export default {
    props: {
        error: {
            type: String,
        },
        config: {
            type: Object as PropType<{ sitekey: string } | null>,
        },
        modelValue: {
            type: String,
        },
    },
    emits: ["enter", "update:modelValue", "update"],
    expose: ["execution", "reset"],
    data() {
        return {
            loading: true,
            id: uuid(),
            widgetId: null as WidgetId,
            token: null,
            invisible: true,
        };
    },
    computed: {
        captcha: function(): YcCaptcha {
            const captcha = (window as any).smartCaptcha;
            if (!captcha) {
                throw new Error('SmartCaptcha is not initialized');
            }
            return captcha;
        },
    },
    unmounted() {
        const captcha = this.captcha;
        try {
            if (captcha) {
                captcha.reset();
            }
        } catch (err) {
            console.info(err);
        }

    },
    async mounted() {
        (window as any)[this.getCallbackName()] = (token) => {
            this.onloadFunction(token);
        };

        const captcha = this.captcha;
        const container = document.getElementById(this.id);
        this.widgetId = captcha.render(container, {
            sitekey: this.config?.sitekey,
            callback: this.getCallbackName(),
            invisible: this.invisible,
            hideShield: true,
            test: true,
        });
    },
    methods: {
        async execution(): Promise<any> {
            return new Promise((resolve, reject) => {
                const captcha = this.captcha;
                captcha.subscribe(this.widgetId, "success", (token: string) => {
                    resolve(null);
                    this.setToken(token);
                });

                captcha.subscribe(this.widgetId, "token-expired", () => {
                    reject('Token expired');
                });
                captcha.subscribe(this.widgetId, "network-error", () => {
                    reject('Network error');
                });
                captcha.subscribe(this.widgetId, "challenge-hidden", () => {
                    reject(null);
                });

                if (captcha && this.invisible) {
                    captcha.execute(this.widgetId);
                }
            });
        },
        onloadFunction(token) {
            if (this.invisible) {
                return;
            }
        },
        setToken(token: string) {
            this.$emit("update:modelValue", token);
            this.$emit("update", token);
        },
        getCallbackName(): string {
            return "YandexSmartCaptcha" + this.id;
        },
        reset() {
            this.captcha.reset();
        }
    },
};
